import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExperimentalFeaturesFacade, PrincipalConfigurationService } from '../index';

@Injectable()
export class ExperimentalFeaturesService implements ExperimentalFeaturesFacade {
  constructor(private principalConfigurationService: PrincipalConfigurationService) {}

  private hasExperimentalFeature(feature: string) {
    return this.principalConfigurationService
      .getValue('enabledExperimentalFeatures')
      .pipe(map((config) => Boolean(config?.value.toString().split(',').includes(feature))));
  }

  hasIdleDetection(): Observable<boolean> {
    return this.hasExperimentalFeature('IDLE_DETECTION');
  }

  hasSearchScore(): Observable<boolean> {
    return this.hasExperimentalFeature('SEARCH_SCORE');
  }

  hasDebugMenu(): Observable<boolean> {
    return this.hasExperimentalFeature('DEBUG_MENU');
  }
}
